module.exports = __webpack_public_path__ + "img/step2.cf3e16b3.png";